const SCRIPT_URL = "https://js.paystack.co/v1/inline.js";

export function loadPaystack() {
  if (typeof window === "undefined") return Promise.reject(new Error("Paystack requires a browser"));
  if (window.PaystackPop) return Promise.resolve(window.PaystackPop);

  return new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src="${SCRIPT_URL}"]`);
    if (existing) {
      existing.addEventListener("load", () => resolve(window.PaystackPop));
      existing.addEventListener("error", () => reject(new Error("Failed to load Paystack")));
      return;
    }
    const script = document.createElement("script");
    script.src = SCRIPT_URL;
    script.async = true;
    script.onload = () => resolve(window.PaystackPop);
    script.onerror = () => reject(new Error("Failed to load Paystack"));
    document.head.appendChild(script);
  });
}

/**
 * Opens Paystack inline checkout. Resolves with { reference } on success.
 */
export async function openPaystackCheckout({
  publicKey,
  email,
  amountKobo,
  reference,
  channels,
  onClose,
}) {
  if (!publicKey) throw new Error("Paystack is not configured");
  const PaystackPop = await loadPaystack();

  return new Promise((resolve, reject) => {
    const handler = PaystackPop.setup({
      key: publicKey,
      email,
      amount: amountKobo,
      ref: reference,
      ...(Array.isArray(channels) && channels.length ? { channels } : {}),
      callback: (response) => resolve(response),
      onClose: () => {
        onClose?.();
        reject(new Error("Payment cancelled"));
      },
    });
    handler.openIframe();
  });
}
